const currentDate = new Date();

export const getNext7Days = () => {
  const next7Days = [];

  for (let i = 0; i < 7; i++) {
    const nextDate = new Date();
    nextDate.setDate(currentDate.getDate() + i); // Increment by i days

    next7Days.push({
      day: nextDate.getDate(),
      month: nextDate.toLocaleString("en-GB", { month: "short" }),
      dayName: nextDate.toLocaleString("en-GB", { weekday: "short" }),
      year: nextDate.getFullYear(),
    });
  }

  return next7Days;
};

// Formate DOB
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate(); // Day of the month
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()]; // Short month name
  const year = date.getFullYear(); // Full year
  return `${day} ${month} ${year}`;
};

// Calculate Age
export const calculateAge = (dateString) => {
  const birthDate = new Date(dateString);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();

  // Adjust if the birthday hasn't occurred yet this year
  const isBirthdayPassed =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() >= birthDate.getDate());

  if (!isBirthdayPassed) {
    age--;
  }

  return age;
};

// Current Day Number
export const getCurrentDateNumber = () => {
  const currentDate = new Date();
  return currentDate.getDate();
};

// Current Date
export const getCurrentDate = () => {
  const currentDate = new Date();

  return {
    day: currentDate.getDate(),
    month: currentDate.toLocaleString("en-GB", { month: "short" }),
    dayName: currentDate.toLocaleString("en-GB", { weekday: "short" }),
    year: currentDate.getFullYear(),
  };
};

// Next Date
export const getNextDate = () => {
  const nextDate = new Date();
  nextDate.setDate(nextDate.getDate() + 1); // add 1 day

  return {
    day: nextDate.getDate(),
    month: nextDate.toLocaleString("en-GB", { month: "short" }),
    dayName: nextDate.toLocaleString("en-GB", { weekday: "short" }),
    year: nextDate.getFullYear(),
  };
};


// Utility function to format ISO date
export const formatDateToInput = (isoDate) => {
  if (!isoDate) return "";
  return new Date(isoDate).toISOString().split("T")[0];
};
